<template>
  <div class="mb-5">
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="4" style="text-align: start ;padding:10px 20px 0 20px ">
                <strong v-if="status_form==0">{{ $t('components.addComplimentary') }}</strong>
                <strong v-if="status_form!=0">{{ $t('components.editComplimentary') }}</strong>

              </CCol>
              <CCol col="4" style="text-align: center ;padding:10px 20px 0 20px ">

                <strong v-if="status_form!=0">{{ edit_name }}</strong>

              </CCol>
              <CCol col="4" style="text-align: end">
                <CButton v-if="status_form==0" @click="insert_data()" type="submit" size="sm"
                         color="secondary">
                  {{ $t('buttons.save') }}
                </CButton>
                <CButton v-if="status_form!=0" @click="insert_data()" type="submit" size="sm"
                         color="secondary">
                  {{ $t('components.edit') }}
                </CButton>


              </CCol>
            </CRow>

          </CCardHeader>
          <CCardBody>
            <CRow>


              <CCol sm="3">
                <CInput
                    :label="$t('title')"
                    v-model="title"
                    horizontal
                />
              </CCol>

              <CCol col="3">
                <date-picker
                    horizontal
                    v-model="start_date"
                    :label="$t('components.startDate')"
                ></date-picker>
              </CCol>
              <CCol col="3">
                <date-picker
                    horizontal
                    v-model="end_date"

                    :label="$t('components.endDate')"
                ></date-picker>

              </CCol>

            </CRow>
          </CCardBody>
        </CCard>

        <CCard>
          <CCardHeader>
            <CRow style="justify-content: space-between;">

              <CCol col="3">
                <CSelect
                    :label="$t('tables.type')"
                    :value.sync="festival_detail_obj.selected_type_item"
                    :options="type_items"
                    horizontal

                />
              </CCol>
              <CCol col="1">
                <CButton outlined class="mr-1" color="dark" size="sm"
                         @click="festival_detail.push(JSON.parse(JSON.stringify(festival_detail_obj))),festival_detail_obj={}"
                >
                  <CIcon size="sm" name="cil-plus"/>
                </CButton>
              </CCol>

            </CRow>
          </CCardHeader>

          <CCardBody>
            <CRow>

              <CCol col="12">


              </CCol>
              <CCol col="12">
                <CRow v-if="festival_detail_obj.selected_type_item == 1">
                  <CCol sm="3">
                    <CSelect
                        :options="arziabi_options"
                        :value.sync="festival_detail_obj.arziabi_method"
                        :label="$t('customerType')"

                    />

                  </CCol>
                  <CCol sm="3"
                        v-if="festival_detail_obj.arziabi_method==0 || festival_detail_obj.arziabi_method==null"
                  >

                    <label>{{ $t('components.customer') }}</label>
                    <treeselect
                        v-model="festival_detail_obj.off_person"
                        :placeholder="$t('components.search')"
                        horizontal
                        :async="true"
                        valueFormat="object"

                        :load-options="load_persons"
                        :normalizer="normalizer_persons"
                    />
                    <!--                                        </CCol>-->
                    <!--                                    </CRow>-->

                  </CCol>


                  <CCol col="3"
                        v-if="festival_detail_obj.arziabi_method!=0 && festival_detail_obj.arziabi_method!=null"
                  >
                    <CSelect
                        :label="$t('components.province')"
                        :value.sync="festival_detail_obj.selected_province"
                        @change="get_cities()"
                        :options="province_items"
                    />
                  </CCol>
                  <CCol col="3"
                        v-if="festival_detail_obj.arziabi_method!=0 && festival_detail_obj.arziabi_method!=null"
                  >
                    <CSelect

                        :label="$t('components.city')"
                        :value.sync="festival_detail_obj.selected_city"

                        :options="city_items"
                    />
                  </CCol>

                  <CCol col="3">

                    <CInput
                        :label="$t('components.offPercent')"

                        v-on:keypress="isDecimal($event)"
                        v-model="festival_detail_obj.off_percent"
                    />

                  </CCol>

                </CRow>

                <CRow class="m-0" v-if="festival_detail_obj.selected_type_item == 3">
                  <CCol col="4">
                    <CInput
                        :label="$t('InvoiceAmount')"
                        v-model="festival_detail_obj.min_price"
                    />

                  </CCol>
                  <CCol col="4">

                    <CInput
                        :label="$t('components.offPercent')"
                        v-on:keypress="isDecimal($event)"
                        v-model="festival_detail_obj.min_percent"
                    />

                  </CCol>

                </CRow>

                <CRow v-if="festival_detail_obj.selected_type_item == 2">

                  <CRow class="m-0">

                    <CCol col="2" v-if="get_access('customer_type')">
                      <CSelect
                          :label="$t('GuildType')"

                          :value.sync="festival_detail_obj.selected_guild"
                          :options="guild_items"
                      />
                    </CCol>

                    <CCol col="3">
                      <label>{{ $t('itemDiscount') }}</label>
                      <treeselect
                          v-model="festival_detail_obj.selected_product1"
                          :async="true"
                          valueFormat="object"

                          @select="select_product(festival_detail_obj,...arguments)"
                          :load-options="load_products"
                          :placeholder="$t('components.searchProduct')"
                          :normalizer="normalizer_products"
                      />
                      <div v-if="festival_detail_obj.product_description"
                           class="text-danger">{{ $t('sellPrice') }}{{
                          '   '
                        }}{{ get_currency(festival_detail_obj.product_description) }}
                      </div>
                      <div v-if="festival_detail_obj.product_description_off"
                           class="text-danger"> {{ $t('tables.offPercent') }}
                        {{ get_currency(festival_detail_obj.product_description_off) }}
                      </div>
                    </CCol>
                    <CCol>

                      <CInput
                          :label="$t('components.firstProductQty')"
                          type="number"
                          v-on:keypress="isNumber($event)"
                          v-model="festival_detail_obj.product_count1"
                      />
                    </CCol>
                    <CCol>

                      <CInput
                          :label="$t('components.off')"
                          v-on:keypress="isDecimal($event)"
                          v-model="festival_detail_obj.product_off1"
                      />
                    </CCol>
                    <CCol col="3" v-if="festival_detail_obj.product_off1=='' || festival_detail_obj.product_off1==null">
                      <label>{{ $t('reward') }}</label>

                      <treeselect
                          v-model="festival_detail_obj.selected_product2 "
                          valueFormat="object"

                          :async="true"
                          :load-options="load_products"
                          :placeholder="$t('components.searchProduct')"
                          :normalizer="normalizer_products"
                      />

                    </CCol>

                    <CCol v-if="festival_detail_obj.product_off1=='' || festival_detail_obj.product_off1==null">

                      <CInput
                          :label="$t('components.secondProductQty')"
                          v-on:keypress="isNumber($event)"
                          v-model="festival_detail_obj.product_count2"
                      />
                    </CCol>
                  </CRow>

                </CRow>
              </CCol>

            </CRow>

          </CCardBody>
        </CCard>

        <CCard :key="'festival-'+index" v-for="(det,index) in festival_detail">
          <CCardHeader>
            <CRow style="justify-content: space-between;">
              <CCol col="3">
                {{ $t('tables.type') }}:
                {{ type_items.filter(x => x.value == det.selected_type_item)[0].label }}

              </CCol>
              <CCol col="1">
                <CButton outlined class="mr-1" color="dark" size="sm"
                         @click="festival_detail.splice(index,1)"
                >
                  <CIcon size="sm" name="cil-minus"/>
                </CButton>
              </CCol>
            </CRow>
          </CCardHeader>

          <CCardBody>
            <CRow>

              <CCol col="12">


              </CCol>
              <CCol col="12">
                <CRow v-if="det.selected_type_item == 1">

                  <CCol sm="3" v-if="arziabi_options.filter(x=>x.value == det.arziabi_method).length>0">
                    {{ $t('customerType') }}:
                    {{ arziabi_options.filter(x => x.value == det.arziabi_method)[0].label }}


                  </CCol>
                  <CCol sm="3" v-else>
                    {{ $t('customerType') }}:
                    {{ arziabi_options[0].label }}


                  </CCol>
                  <CCol sm="3"
                        v-if="det.arziabi_method==0 || det.arziabi_method==null"
                  >

                    <label>{{ $t('components.customer') }}:</label>
                    {{ det.off_person.fullName }}

                  </CCol>


                  <CCol col="3"
                        v-if="det.arziabi_method!=0 && det.arziabi_method!=null"
                  >
                    {{ $t('components.province') }}:
                    {{ province_items.filter(x => x.value == det.selected_province)[0].label }}

                  </CCol>
                  <CCol col="3"
                        v-if="det.arziabi_method!=0 && det.arziabi_method!=null"
                  >
                    {{ $t('components.city') }}:
                    <span v-if="city_items.filter(x => x.value == det.selected_city).length>0">
                      {{ city_items.filter(x => x.value == det.selected_city)[0].label }}
                    </span>

                  </CCol>

                  <CCol col="3">
                    {{ $t('components.offPercent') }}:
                    {{ det.off_percent }}


                  </CCol>

                </CRow>

                <CRow class="m-0" v-if="det.selected_type_item == 3">
                  <CCol col="4">

                    {{ $t('InvoiceAmount') }}:
                    {{ det.min_price }}

                  </CCol>
                  <CCol col="4">

                    {{ $t('components.offPercent') }}:
                    {{ det.min_percent }}

                  </CCol>

                </CRow>

                <CRow v-if="det.selected_type_item == 2">

                  <CRow class="m-0">

                    <CCol col="2"
                          v-if="get_access('customer_type') && guild_items.filter(x=>x.value == det.selected_guild).length>0">
                      {{ $t('GuildType') }}:
                      {{ guild_items.filter(x => x.value == det.selected_guild)[0].label }}

                    </CCol>

                    <CCol col="3">
                      <label>{{ $t('itemDiscount') }}:</label>
                      {{ det.selected_product1.productCodeName }}
                    </CCol>
                    <CCol>

                      {{ $t('components.firstProductQty') }}:
                      {{ det.product_count1 }}

                    </CCol>
                    <CCol>

                      {{ $t('components.off') }}:
                      {{ det.product_off1 }}

                    </CCol>
                    <CCol col="3" v-if="det.product_off1=='' || det.product_off1==null">
                      <label>{{ $t('reward') }}:</label>
                      {{ det.selected_product2.productCodeName }}


                    </CCol>

                    <CCol v-if="det.product_off1=='' || det.product_off1==null">

                      {{ $t('components.secondProductQty') }}:
                      {{ det.product_count2 }}


                    </CCol>
                  </CRow>

                </CRow>
              </CCol>

            </CRow>

          </CCardBody>
        </CCard>

      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import Vue from "vue";

import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import BTab from "../../tabs/BTab";
import BTabs from "../../tabs/BTabs";

var simulateAsync = null
const simulateAsyncOperation = fn => {
  if (simulateAsync != null) {
    clearTimeout(simulateAsync)
  }
  simulateAsync = setTimeout(fn, 1000)
}
var items = [];


export default {
  name: 'AddEshantion',
  components: {
    BTabs,
    BTab,
    Treeselect,

  },
  data() {
    return {
      start_date: '',
      end_date: '',
      title: '',
      selected_guild: 0,
      guild_items: [],

      selected_type_item: 0,
      type_items: [],

      festival_detail: [],
      festival_detail_obj: {},

      name: '',
      file: '',
      color: '#ffffff',
      previewImage: '',
      description: '',


      details: [],
      collapseDuration: 0,
      status_form: 0,


      min_price: '',
      min_percent: '',

      off_code: '',
      off_percent: '',

      product_name1: '',
      product_count1: '',
      product_unit1: '',
      product_off1: '',
      arziabi_options: [],
      product_name2: '',
      product_count2: '',
      product_unit2: '',

      unit_items: [],

      unit_items_filtered1: [],
      selected_place1: 0,
      selected_product1: null,

      unit_items_filtered2: [],
      selected_place2: 0,
      selected_product2: null,
      product_description: '',
      product_description_off: '',

      province_items: [],
      selected_province: 0,


      country_items: [],
      selected_country: 0,

      city_items: [],
      selected_city: 0,

      load_products({action, searchQuery, callback}) {
        var self = this;

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);

            axios.post('GetProducts', formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

              // localStorage.setItem("api_token", response.data.access_token);
              // self.$router.push({ path: 'notes' });
            })
                .catch(function (error) {

                  console.log(error);
                });


            //  const options = this.get_keywords(searchQuery);
            // const options = [1, 2, 3, 4, 5].map(i => ({
            //     id: `${searchQuery}-${i}`,
            //     name: `${searchQuery}-${i}`,
            // }))

          })
        }
      },
      normalizer_products(node) {
        return {
          id: node.id,
          label: node.productCodeName,
        }
      },


      load_persons({action, searchQuery, callback}) {
        var self = this;

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);
            formData.append('IsVendor', false);
            formData.append('IsWorker', false);
            formData.append('IsCustomer', true);
            formData.append('IsActive', 0);

            axios.post('GetAllPersons', formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

              // localStorage.setItem("api_token", response.data.access_token);
              // self.$router.push({ path: 'notes' });
            })
                .catch(function (error) {

                  console.log(error);
                });


            //  const options = this.get_keywords(searchQuery);
            // const options = [1, 2, 3, 4, 5].map(i => ({
            //     id: `${searchQuery}-${i}`,
            //     name: `${searchQuery}-${i}`,
            // }))

          })
        }
      },
      normalizer_persons(node) {
        return {
          id: node.userId,
          label: node.personCode + " " + node.userName + " " + node.surName + " " + node.mobileNo,
        }
      },

    }
  },
  mounted() {
    this.start_date = this.get_today()
    this.end_date = this.get_today()
    this.$root.root_validate_errors = [];
    this.get_product_units();
    this.get_guild_types();

    this.get_types();
    this.get_sys();
    this.get_country();

    // this.get_lists();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  },
  watch: {
    'selected_product1': function () {
      this.get_product_data(1)
    },
    'selected_product2': function () {
      this.get_product_data(2)
    },

    'selected_country': function () {
      this.get_provinces();
    },
    'selected_province': function () {
      this.get_cities();
    },
  },
  methods: {
    get_provinces() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.selected_country);


      axios.post('GetStateList', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.province_items = [];
          self.province_items.push({label: self.$t('dialogs.insertProvince'), value: 0});
          self.province_items = self.sort_array(self.province_items, content_data.data, 'id', 'provinceName')
          // content_data.data.forEach((val) => {
          //   self.province_items.push({label: val.provinceName, value: val.id});
          // });

          // self.province_items = content_data.data;


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_country() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetCountries', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.country_items = [];
          self.country_items = self.sort_array(
              self.country_items, content_data.data,
              'id', 'title');

          self.selected_country = self.country_items[0].value;
          self.selected_country2 = self.country_items[0].value;
          if (self.$i18n.locale == 'fa') {
            self.selected_country = self.country_items.filter(x => x.label == 'ایران')[0].value
            self.selected_country2 = self.country_items.filter(x => x.label == 'ایران')[0].value
          }
          if (self.$i18n.locale == 'en') {
            self.selected_country = self.country_items.filter(x => x.label == 'England')[0].value
            self.selected_country2 = self.country_items.filter(x => x.label == 'England')[0].value
          }
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }


      }).catch(function (error) {

        console.log(error);
      });

    },
    get_cities() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.festival_detail_obj.selected_province);

      axios.post('GetCityListByStateId', formData, {show_pros: true}).then(function (response) {

        var content_data = response.data;
        self.city_items = [];
        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          var obj = {label: self.$t('dialogs.insertCity'), value: 0}
          self.city_items.push(obj);
          self.city_items = self.sort_array(
              self.city_items, content_data.data,
              'cityId', 'cityName');


          // self.city_items = content_data.data;


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    select_product(det, node) {
      det.product_description = node.salePrice
      det.product_description_off = node.takhfif
    },
    get_sys() {
      var self = this;

      const formData = new FormData();

      axios.post('GetSysPersonGlobals', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;

        self.arziabi_options = [{label: self.$t('SpecificCustomer'), value: 0}];

        content_data.forEach((val) => {
          var obj = {label: val.title, value: val.id}


          if (val.titleType == 21) {
            self.arziabi_options.push(obj);
          }

        });



      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_product_data(val) {

      let self = this;
      const formData = new FormData();
      let url;
      url = "GetProductById";
      if (val == 1) {
        formData.append('id', this.selected_product1);
      }
      if (val == 2) {
        formData.append('id', this.selected_product2);
      }
      formData.append('PersonId', 0);

      axios.post(url, formData, {}).then((res) => {
        var base_id = 0;

        if (val == 1) {
          self.product_name1 = res.data.data.productName;
          self.unit_items_filtered1 = [];
          self.unit_items.forEach((val) => {
            if (val.id == res.data.data.productUnitId) {
              self.unit_items_filtered1.push(val);
              self.product_unit1 = val.id;
              base_id = val.baseUnitId;
            }
            // val.row_id = row_index;
            // row_index += 1;

          });
          self.unit_items.forEach((val) => {
            if (val.id == base_id) {
              self.unit_items_filtered1.push(val);
              // self.product_unit = val.id;
              // base_id = val.baseUnitId;
            }
            // val.row_id = row_index;
            // row_index += 1;

          });
          self.unit_items_filtered1.forEach((val) => {
            if (val.id == res.data.data.productUnitId) {
              self.product_unit1 = val.id;
            }

          });

        }
        if (val == 2) {
          self.product_name2 = res.data.data.productName;
          self.unit_items_filtered2 = [];
          self.unit_items.forEach((val) => {
            if (val.id == res.data.data.productUnitId) {
              var obj = {label: val.unitName, value: val.id}

              self.unit_items_filtered2.push(obj);
              // self.unit_items_filtered2.push(val);
              self.product_unit2 = val.id;
              base_id = val.baseUnitId;
            }
            // val.row_id = row_index;
            // row_index += 1;

          });
          self.unit_items.forEach((val) => {
            if (val.id == base_id) {
              var obj = {label: val.unitName, value: val.id}

              self.unit_items_filtered2.push(obj);
              // self.unit_items_filtered2.push(val);
              // self.product_unit = val.id;
              // base_id = val.baseUnitId;
            }
            // val.row_id = row_index;
            // row_index += 1;

          });
          self.unit_items_filtered.forEach((val) => {
            if (val.id == res.data.data.productUnitId) {
              self.product_unit2 = val.id;
            }

          });

        }

        //self.unit_items_filtered =  self.unit_items.filter(item => item.id==res.data.data.productUnitId);
        // var row_index = 0;


      })
          .catch(function (error) {

            console.log(error);
          });


    },
    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.name != '' && this.file != '' && this.description != '' && this.color != '') {
        return true;
      }


      // if (this.name == '') {
      //     this.$root.root_validate_errors.push('نام را وارد کنید');
      // }
      // if (this.file == '') {
      //     this.$root.root_validate_errors.push('تصویر را انتخاب کنید');
      // }
      // if (this.color == '') {
      //     this.$root.root_validate_errors.push('رنگ را انتخاب کنید');
      // }
      // if (this.description == '') {
      //     this.$root.root_validate_errors.push('توضیحات را وارد کنید کنید');
      // }
      return false;
      // e.preventDefault();
    },
    get_user_data() {

      let self = this;
      const formData = new FormData();
      let url;
      url = "GetPersonById";

      formData.append('id', this.off_person);


      axios.post(url, formData, {}).then((res) => {

        self.off_person_name = res.data.data.personName;


      })
          .catch(function (error) {

            console.log(error);
          });


    },
    validateProduct: function () {
      this.$root.root_validate_errors = [];


      if (this.product_name1 != '' && this.product_count1 != '' && this.product_unit1 != '' && this.product_count1 != 0) {
        return true;


      }

      if (this.product_name1 == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }
      if (this.product_count1 == '' || this.product_count1 == 0) {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertProductQty'));
      }

      if (this.product_unit1 == "") {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertUnit'));
      }


      return false;
      // e.preventDefault();
    },
    add_product_to_document() {
      if (this.validateProduct()) {
        console.log("units", JSON.stringify(this.unit_items));
        var product_new_item = [];

        this.unit_items.forEach((val) => {
          if (val.id == this.product_unit1) {
            product_new_item.unit_value1 = val.value;
          }
          // val.row_id = row_index;
          // row_index += 1;

        });
        this.unit_items.forEach((val) => {
          if (val.id == this.product_unit2) {
            product_new_item.unit_value2 = val.value;
          }
          // val.row_id = row_index;
          // row_index += 1;

        });
        // console.log("pro units",JSON.stringify(product_new_item.unit_value2)," ",JSON.stringify(product_new_item.unit_value1));

        product_new_item.name1 = this.product_name1;
        product_new_item.name2 = this.product_name2;
        product_new_item.unit1 = this.product_unit1;
        product_new_item.unit2 = this.product_unit2;
        product_new_item.count1 = this.product_count1;
        product_new_item.count2 = this.product_count2;
        if (this.product_off1 != null) {
          product_new_item.off = this.product_off1;

        } else {
          product_new_item.off = 0;

        }
        product_new_item.product_id1 = this.selected_product1;
        product_new_item.product_id2 = this.selected_product2;
        console.log("product ", JSON.stringify(product_new_item));

        this.product_items.push(product_new_item);
        this.product_name1 = "";
        this.product_name2 = "";
        this.product_unit1 = "";
        this.product_unit2 = "";
        this.product_count1 = "";
        this.product_count2 = "";
        this.product_off1 = "";
        console.log("products", this.product_items);
        console.log("products", this.product_items.length);

        var row_index = 0;
        this.product_items.forEach((val) => {
          val.row_id = row_index;
          row_index += 1;

        });
      }
    },
    get_style(color) {
      return {
        backgroundColor: color

      }
    },
    edit_item(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = this.items[item.row_id].unitName;
      this.color = this.items[item.row_id].color;
      this.description = this.items[item.row_id].description;
      this.previewImage = this.items[item.row_id].image;
      this.status_form = this.items[item.row_id].id;
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    get_product_units() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetProductUnits', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.unit_items = content_data.data;


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

        // console.log("cats is "+items);
        // self.description = '';
        // localStorage.setItem("api_token", response.data.access_token);
        // self.$router.push({ path: 'notes' });
      })
          .catch(function (error) {

            console.log(error);
          });

    },


    emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '';
      this.status_form = 0;

      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    get_types() {
      var self = this;


      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetSysEshantionTypes', formData, {
        params: {
          // isparent : self.$route.params.cat_id
        },
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        var el = {value: '0', label: self.$t('components.selectType')};
        self.type_items.push(el);
        content_data.data.forEach((val) => {
          var el = {value: val.eshanTypeId, label: val.eshanTypeTitle};
          self.type_items.push(el);
        });


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    goSubCategories(item) {

      this.$router.push({path: "/dashboard/products/list-brand/" + item.id})
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    get_guild_types() {
      var self = this;


      const formData = new FormData();

      axios.post('GuildUnitTitle/GetData', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;


          self.guild_items = [{label: self.$t('all'), value: 0}];
          self.guild_items = self.sort_array(
              self.guild_items, content_data.data,
              'id', 'title');


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },

    insert_data() {
      var self = this
      this.festival_detail.forEach(function (val) {
        if (val.selected_type_item == null) {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.warning"), self.$t('dialogs.selectComplimentaryType'), [self.$t("dialogs.ok")], 'danger');

          return true;
        }
        if (val.selected_type_item == 1 ) {

          if(val.arziabi_method==0 && val.arziabi_method==null ){
            if (val.off_percent == null || val.off_person == null) {
              self.$root.modal_component.show_danger_modal(self.$t("dialogs.warning"), self.$t('dialogs.fillAllFields'), [self.$t("dialogs.ok")], 'danger');
              return true;
            }
          }else{
            if (val.off_percent == null) {
              self.$root.modal_component.show_danger_modal(self.$t("dialogs.warning"), self.$t('dialogs.fillAllFields'), [self.$t("dialogs.ok")], 'danger');
              return true;
            }
          }

        }
        if (val.selected_type_item == 2) {
          if (val.selected_product1 == null || val.product_count1 == null || val.product_count1 == "0") {
            self.$root.modal_component.show_danger_modal(self.$t("dialogs.warning"), self.$t('dialogs.fillAllFields'), [self.$t("dialogs.ok")], 'danger');

            return true;
          }
        }
        if (val.selected_type_item == 3) {
          if (val.min_price == null || val.min_price == "0" || val.min_percent == null) {
            self.$root.modal_component.show_danger_modal(self.$t("dialogs.warning"), self.$t('dialogs.fillAllFields'), [self.$t("dialogs.ok")], 'danger');

            return true;
          }
        }
      })

      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "AddEshantion";
      } else {
        url = "EditEshantionMaster";
        formData.append('id', this.status_form)

      }


      var sending_products = [];
      var pro_obj = {};
      var final_sending = {};
      this.festival_detail.forEach(function (val) {

        if (val.selected_type_item == 1) {


          pro_obj = {
            EshantionType: val.selected_type_item,
            PersonName: val.off_person_name,
            PersonId: 0,

            TakhfifCode: val.off_code,
            Takhfif: val.off_percent,
            ProvinceId:val.selected_province,
            CityId:val.selected_city,
            PersonType:val.arziabi_method
          };
          if(val.arziabi_method==0 || val.arziabi_method==null){
            pro_obj.PersonId= val.off_person.userId
          }


          sending_products.push(pro_obj);

        }
        if (val.selected_type_item == 2) {

          pro_obj = {
            GuildUnitId: val.selected_guild,

            EshantionType: val.selected_type_item,
            Takhfif: val.product_off1,
            FirstProductId: val.selected_product1.id,
            FirstUnitId: val.product_unit1,
            Qty: val.product_count1,
            ResultProductId: val.selected_product2.id,
            ResultUnitId: val.product_unit2,
            ResultQty: val.product_count1
          };
          if (pro_obj.GuildUnitId == null) {
            pro_obj.GuildUnitId = 0;
          }
          sending_products.push(pro_obj);

        }
        if (val.selected_type_item == 3) {

          pro_obj = {
            EshantionType: val.selected_type_item,
            Takhfif: val.min_percent,
            Price: val.min_price,
          };
          sending_products.push(pro_obj);

        }
      })
      // formData.append('EshantionType', this.selected_type_item);

      final_sending = {'Recs': sending_products};
      formData.append('Dto', JSON.stringify(final_sending));
      formData.append('EshantionStart', this.start_date);
      formData.append('EshantionEnd', this.end_date);
      formData.append('EshantionTitle', this.title);


      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);
        if (res.data.statusCode == 0) {
          self.status_form = 0;
          self.title = '';
          self.festival_detail = [];
          self.festival_detail_obj={}

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
  }
}

</script>
